import { Component, Vue, Watch } from 'vue-property-decorator';
import appStore from '@/store/app';
import partnersService from '@/services/PartnersService';
import { Partner } from '@/models';
import { debounce } from '@/core/debounce';
import CardComponent from '@/components/CardComponent';

@Component({
   components: { CardComponent },
})
export default class Partners extends Vue {

   private keyword = '';
   private selected: Partner | null = null;
   private partners: Partner[] = [];
   private total = 0;
   private readonly minLength = 3;

   private debouncedFetchPartnersAsync = async (): Promise<void> => undefined;

   get loading(): boolean {
      return appStore.isLoading;
   }

   private async created() {
      this.debouncedFetchPartnersAsync = debounce(this.fetchPartnersAsync, 600);
   }

   private async mounted() {
      await appStore.activateMenuById({ rootId: 400, subMenuId: 403 });
   }

   @Watch('keyword', { immediate: false, deep: false })
   private async onKeywordChanged(value: string, previousValue?: string) {

      if (previousValue === undefined) return;

      if (value.trim() === '' || value.trim().length >= this.minLength) {
         await this.debouncedFetchPartnersAsync();
      }
   }

   private async fetchPartnersAsync() {
      if (this.keyword.length < this.minLength) {
         this.partners = [];
         return;
      }
      await partnersService.fetchPartnersAsync(this.keyword)
         .then((result) => {
            this.total = result.total || 0;
            this.partners = [];
            result.payload.forEach((partner) => this.partners.push(partner));
         });
   }

   private select(row: Partner, oldRow: Partner | null): void {
      this.selected = row;
   }


   private async syncProductsHistory(partner: Partner) {
      this.$buefy.dialog.confirm({
         title: 'Sincronizzazione Storico Prodotti',
         message: 'Sei sicuro/a di voler <b>sincronizzare</b> lo storico prodotti ?',
         confirmText: 'Conferma',
         cancelText: 'Annulla',
         type: 'is-warning',
         hasIcon: true,
         onConfirm: async () => await this.syncProductsHistoryAsync(partner),
      });
   }

   private async syncOrdersHistory(partner: Partner) {
      this.$buefy.dialog.confirm({
         title: 'Sincronizzazione Storico Ordini',
         message: 'Sei sicuro/a di voler <b>sincronizzare</b> lo storico degli ordini ?',
         confirmText: 'Conferma',
         cancelText: 'Annulla',
         type: 'is-warning',
         hasIcon: true,
         onConfirm: async () => await this.syncOrdersHistoryAsync(partner),
      });
   }

   private async syncProductsHistoryAsync(partner: Partner) {
      await partnersService.syncProductsHistoryAsync(parseInt(partner.code, 0));
   }

   private async syncOrdersHistoryAsync(partner: Partner) {
      await partnersService.syncOrdersHistoryAsync(parseInt(partner.code, 0));
   }
}
